import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuthService extends BaseService {
  private clientId: string = 'napp.solutions@cacaushow.com.br';
  private clientSecret: string = '@OM*GXueiB5wthakxK';

  constructor(private http: HttpClient) {
    super();
  }

  retornaStatusMembro(
    cpf: string,
    senha: string,
    verificaStatus: boolean
  ): Observable<any> {
    let object = new Object({
      cpf: cpf,
      senha: senha,
      verificaStatus: verificaStatus,
    });

    let response = this.http
      .post(`${this.UrlService}Autenticacao`, object, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  loginComSenha(cpf: string, senha: string): Observable<any> {
    let object = new Object({ cpf: cpf, senha: senha });

    let response = this.http
      .post(`${this.UrlService}Autenticacao`, object, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  loginComToken(token: string) {
    if (token.includes('?utm_source=marketingcloud'))
      token = token.split('?utm_source=marketingcloud')[0];

    let response = this.http
      .get(
        this.UrlService + 'AutenticacaoPorToken?token=' + token,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  validacaoTokenSemLifeTime(token: string) {
    let response = this.http
      .get(
        this.UrlService +
          'AutenticacaoPorTokenSemTempoDeExpiracao?token=' +
          token,
        this.obterHeaderJson()
      )
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  getIPAddress() {
    let response = this.http
      .get('https://api.ipify.org/?format=json')
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }

  loginOms() {
    const request = {
      clientId: this.clientId,
      clientSecret: this.clientSecret,
    };

    let response = this.http
      .post(`${this.UrlAuth}/jwt/token`, request, this.obterHeaderJson())
      .pipe(map(this.extractData), catchError(this.serviceError));

    return response;
  }
}
